export enum MercerDirectReportsFilter {
  AllMembers = 0,
  DirectReports
}
